<div data-testid="sleep-measurements" class="small">
  <div class="row mx-0">
    <app-form-field-display
      class="col-6"
      [label]="'analysisLabelStartTime'"
      [value]="measurements.startTime | appLocalDateTime"
    ></app-form-field-display>
    <app-form-field-display
      class="col-6"
      [label]="'sleepReportLabelDurationAfterEditing'"
      [value]="measurements.totalSleepTime"
    ></app-form-field-display>
  </div>

  <div class="row mx-0 my-2">
    <p class="col-12 strong mb-0">
      {{ "sleepReportLabelAhi" | localize }} = {{ number(measurements.ahiIndex) }}
      <span class="ps-4">{{ "sleepReportLabelOdi3" | localize }} = {{ number(measurements.odi3Index) }}</span>
    </p>
  </div>

  <table class="table table-sm table-borderless table-striped-even table-grid-aligned">
    <thead>
      <tr>
        <th scope="col">{{ "sleepReportLabelPosition" | localize }}</th>
        <th *ngFor="let column of positionColumns()" scope="col" class="text-center">{{ column.label | localize }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of positionRows">
        <th scope="row">{{ row.label | localize }}</th>
        <td *ngFor="let column of positionColumns()" class="text-center">{{ row.value(column.position) }}</td>
      </tr>
    </tbody>
  </table>

  <div class="row mx-0">
    <div class="col-6 px-0">
      <ng-container *ngTemplateOutlet="measurementTable; context: {rows: oxygenRows()}"></ng-container>
    </div>
    <div class="col-6 px-0">
      <ng-container *ngTemplateOutlet="measurementTable; context: {rows: breathingAndHeartRows()}"></ng-container>
    </div>
  </div>
</div>

<ng-template #measurementTable let-rows="rows">
  <table class="table table-sm table-borderless table-striped-even table-grid-aligned">
    <tbody>
      <tr *ngFor="let row of rows">
        <th scope="row">{{ row.label | localize }}</th>
        <td class="text-end">
          {{ row.value }}
          <ng-container *ngIf="row.isPieces">{{ "sleepReportUnitPieces" | localize }}</ng-container>
        </td>
      </tr>
    </tbody>
  </table>
</ng-template>
